import React from "react"; // Fixed Grid v2 migration - xs props to size props
import { navigationResources } from "./.resources";
import { useResources } from "../../hooks/useResources";
import { Grid, Typography, Link } from "@mui/material";
import { makeStyles } from "@mui/styles";
import BWIcon from "../../images/iconBW64x64.svg";
import { useNavigate } from "react-router-dom";
import * as urls from "../../types/Constants";
import { ISession } from "../../types/Auth";
import { ThemeOptions } from "../../types/Enums";

interface IFooterProps {
  session: ISession;
  themeName: ThemeOptions;
}

const Footer: React.FC<IFooterProps> = () => {
  const navigate = useNavigate();
  
  // Language sync is handled globally in App.tsx
  const res = useResources(navigationResources);

  const useStyles = makeStyles({
    contactUsItem: {
      padding: "6px 0px 6px 0px",
      color: "silver",
    },
    serviceItem: {
      padding: "6px 0px 6px 0px",
      color: "silver",
    },
    emailItem: {
      padding: "6px",
      color: "silver",
    },
    legalContainer: {
      backgroundColor: "black",
      padding: "6px 100px 6px 100px",
    },
    copyrightItem: {
      padding: "8px",
      textAlign: "center",
      color: "silver",
      width: "100%",
    },
    legalItem: {
      padding: "8px",
      textAlign: "center",
      minWidth: "200px",
      color: "silver",
    },
  });
  const styles = useStyles();

  //const markup=()=>
  function renderEmail() {
    return {
      __html:
        "contact" + decodeURIComponent(escape(window.atob("QHNvZnRpb24uY29t"))),
    };
  }

  const CompanyInfoComponent = () => {
    return (
      <Grid
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="flex-start"
      >
        <Grid container direction="row">
          <img
            alt="logo"
            src={BWIcon}
            style={{ width: 32, height: 32, opacity: 0.8 }}
          />
          <div
            className={styles.emailItem}
            dangerouslySetInnerHTML={renderEmail()}
          ></div>
        </Grid>
        <Grid>
          <Typography className={styles.contactUsItem} variant="body2">
            {res.companyId}
          </Typography>
          <Typography className={styles.contactUsItem} variant="body2">
            {res.companyAddress}
          </Typography>
        </Grid>
      </Grid>
    );
  };

  const ServicesComponent = () => {
    return (
      <Grid
        id="gridServices"
        container
        direction="column"
        justifyContent="flex-start"
        sx={{ width: "100%" }}
        alignItems="center"
      >
        <Typography variant="body1">{res.frequentQuestions}</Typography>
        <Link href="#" onClick={() => navigate(urls.URL_FAQ_PURCHASING)}>
          <Typography variant="body2" className={styles.serviceItem}>
            <u>{res.faqPurchasing}</u>
          </Typography>
        </Link>
        <Typography variant="body2" className={styles.serviceItem}>
          {res.faqLicensing}
        </Typography>
        <Typography variant="body2" className={styles.serviceItem}>
          Contact Support
        </Typography>
      </Grid>
    );
  };

  const ContactNumbersComponent = () => {
    return (
      <Grid
        container
        direction="column"
        justifyContent="right"
        alignItems="center"
      >
        <Typography variant="body1">{res.contactNumbers}</Typography>
        <Typography className={styles.contactUsItem} variant="body2">
          {res.phoneUk}
        </Typography>
        <Typography
          className={styles.contactUsItem}
          variant="body2"
          gutterBottom={false}
        >
          {res.phoneMex}
        </Typography>
      </Grid>
    );
  };

  const TermsAndConditionsComponent = () => {
    return (
      <Link href="#" onClick={() => navigate(urls.URL_TERMS_AND_CONDITIONS)}>
        <Typography className={styles.legalItem} variant="caption">
          {res.termsAndConditions}
        </Typography>
      </Link>
    );
  };

  const PrivacyPolicyComponent = () => {
    return (
      <Link href="#" onClick={() => navigate(urls.URL_PRIVACY_POLICY)}>
        <Typography className={styles.legalItem} variant="caption">
          {res.privacyPolicy}
        </Typography>
      </Link>
    );
  };

  const CopyrightComponent = () => {
    return (
      <Typography className={styles.copyrightItem} variant="caption">
        Copyright &copy; {new Date().getFullYear()} - Softion Solutions Ltd
      </Typography>
    );
  };

  return (
    <Grid container style={{ height: "100%", width: "100%" }}>
      <Grid sx={{ display: { xs: "none", sm: "block" }, width: "100%" }}>
        <Grid
          container
          direction="row"
          sx={{
            color: "white",
            padding: "32px 100px 48px 100px",
            margin: "0px",
            alignItems: "right",
          }}
        >
          <Grid container size={{ xs: 4 }}>
            <CompanyInfoComponent />
          </Grid>
          <Grid container size={{ xs: 4 }} sx={{ alignContent: "center" }}>
            <ServicesComponent />
          </Grid>
          <Grid container size={{ xs: 4 }}>
            <ContactNumbersComponent />
          </Grid>
        </Grid>
      </Grid>

      <Grid sx={{ display: { xs: "block", md: "none" }, width: "100%" }}>
        <Grid
          container
          direction="column"
          sx={{
            color: "white",
            padding: "32px",
            margin: "0px",
            alignItems: "center",
          }}
        >
          <Grid>
            <CompanyInfoComponent />
          </Grid>
          <Grid>
            <ContactNumbersComponent />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        className={styles.legalContainer}
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{
          width: "100%",
          direction: { xs: "column", sm: "row" },
        }}
      >
        <Grid container justifyContent="center">
          <CopyrightComponent />
        </Grid>
        <Grid container justifyContent="center">
          <TermsAndConditionsComponent />
        </Grid>
        <Grid container justifyContent="center">
          <PrivacyPolicyComponent />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Footer;
